/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
  url_im: process.env.VUE_APP_BASE_API
};
export default {
  //白名单查询
  whiteLit: {
    query: `${base.url}/newmis36/white/list`,
    addOrUpdate: `${base.url}/newmis36/white/addOrUpdate`,
    deleteBatchIds: `${base.url}/newmis36/white/deleteBatchIds`,
  },
  //白名单查询
  creditLevel: {
    query: `${base.url}/newmis36/creditlevel/list`,
    logQuery: `${base.url}/newmis36/creditlevel/logList`,
    download: `${base.url}/newmis36/creditlevel/downloadCreditLevel`,
    uploadTemplate: `${base.url}/newmis36/creditlevel/uploadTemplate`,
    addOrUpdate: `${base.url}/newmis36/creditlevel/edit`,
    deleteBatchIds: `${base.url}/newmis36/white/deleteBatchIds`,
  },
  //人脸配置
  face: {
    recordQuery: `${base.url}/cloud/faceRecord/list`,
    statisticsQuery: `${base.url}/cloud/faceStatistics/list`,
    download: `${base.url}/cloud/faceRecord/export`,
    channelQuery: `${base.url}/cloud/faceChannel/list`,
    channelEdit: `${base.url}/cloud/faceChannel/edit`,
    channelStatus: `${base.url}/cloud/faceChannel/status`,
    channeldel: `${base.url}/cloud/faceChannel/del`,
    channelMap: `${base.url}/cloud/faceChannel/getMapKey`,
    channelSetChannel: `${base.url}/cloud/faceChannel/setChannel`,
    configList: `${base.url}/cloud/faceSwitch/list`,
    configEdit: `${base.url}/cloud/faceSwitch/edit`,
    configdel: `${base.url}/cloud/faceSwitch/del`,

  },
  registeruserlog: {
    query: `${base.url}/newmis36/tregisteruserlog/list`,
    down: `${base.url}/newmis36/tregisteruserlog/export`,
    createAccount: `${base.url}/newmis36/tregisteruserlog/createAccount`,
  },
  registervalidate: {
    query: `${base.url}/newmis36/tregistervalidatelog/list`,
    export: `${base.url}/newmis36/tregistervalidatelog/export`,
  },
  riskchecktarget: {
    query: `${base.url}/newmis36/riskchecktarget/list`,
    edit: `${base.url}/newmis36/riskchecktarget/edit`,
    delete: `${base.url}/newmis36/riskchecktarget/del`,
  },
  riskcheckrule: {
    query: `${base.url}/newmis36/riskcheckrule/list`,
    edit: `${base.url}/newmis36/riskcheckrule/edit`,
    delete: `${base.url}/newmis36/riskcheckrule/del`,
  },
  riskSWitch: {
    query: `${base.url}/newmis36/riskchecktarget/riskSwitchList`,
    edit: `${base.url}/newmis36/riskchecktarget/editRiskSwitch`,
  },
  tracker: {
    query: `${base.url}/newmis36/ttracker/list`,
    export: `${base.url}/newmis36/ttracker/export`,
    margin: `${base.url}/newmis36/ttracker/margin`,
  },
  advertising: {
    query: `${base.url}/newmis36/advertising/list`,
    edit: `${base.url}/newmis36/advertising/edit`,
    save: `${base.url}/newmis36/advertising/save`,
    del: `${base.url}/newmis36/advertising/del`,
    getData: `${base.url}/newmis36/advertising/getData`,
    upload: `${base.url}/cloud/file/uploadImage`,
    configQuery: `${base.url}/newmis36/advertisingConfig/list`,
    configEdit: `${base.url}/newmis36/advertisingConfig/edit`,
    configSave: `${base.url}/newmis36/advertisingConfig/save`,
    configDel: `${base.url}/newmis36/advertisingConfig/del`,
  },
  //返利活动
  rebateActivity: {
    list: `${base.url}/newmis36/rebate/list`,
    proposalList: `${base.url}/newmis36/rebate/proposalList`,
    save: `${base.url}/newmis36/rebate/save`,
    edit: `${base.url}/newmis36/rebate/edit`,
    applyProposal: `${base.url}/newmis36/rebate/applyProposal`,
    cancelProposal: `${base.url}/newmis36/rebate/cancelProposal`,
    downloadActivity: `${base.url}/newmis36/rebate/downloadActivity`,
    downloadProActivity: `${base.url}/newmis36/rebate/downloadProActivity`,
    editActiveStatus: `${base.url}/newmis36/rebate/editActiveStatus`,
    queryAll: `${base.url}/newmis36/rebate/queryAllList`,
    symbols:`${base.url}/newmis36/rebate/product/symbols`,
  },
  //返利记录
  tradingRebate: {
    effectiveCustomerList: `${base.url}/newmis36/tradingRebate/effectiveCustomerList`,
    tradeDetailsList: `${base.url}/newmis36/tradingRebate/tradeDetailsList`,
    tradeLogList: `${base.url}/newmis36/tradingRebate/tradeLogList`,
    downloadTradeDetails: `${base.url}/newmis36/tradingRebate/downloadTradeDetails`,
    downloadEffectiveCustomer: `${base.url}/newmis36/tradingRebate/downloadEffectiveCustomer`,
    export:`${base.url}/newmis36/rebateBlack/uploadBlack`,
    blackList:`${base.url}/newmis36/rebateBlack/list`,
    blackListForActive:`${base.url}/newmis36/rebateBlack/getBlackList`,
    getTotalAmount:`${base.url}/newmis36/tradingRebate/getTotalAmount`,
  },
  //入账提交
  depositDetails: {
    list: `${base.url}/newmis36/depositDetails/list`,
    proposalList: `${base.url}/newmis36/depositDetails/proposalList`,
    submitProposal: `${base.url}/newmis36/depositDetails/submitProposal`,
    cancelProposal: `${base.url}/newmis36/depositDetails/cancelProposal`,
    approvalProposal: `${base.url}/newmis36/depositDetails/approvalProposal`,
    refuseProposal: `${base.url}/newmis36/depositDetails/refuseProposal`,
    edit: `${base.url}/newmis36/depositDetails/edit`,
    downloadList: `${base.url}/newmis36/depositDetails/downloadList`,
    downloadLimit: `${base.url}/newmis36/depositDetails/downloadLimit`,
    getTotalAmount: `${base.url}/newmis36/depositDetails/getTotalAmount`,
    newSubmitProposal: `${base.url}/newmis36/depositDetails/newSubmitProposal`,
  },
  //客户推荐关系
  customerRelation: {
    list: `${base.url}/newmis36/customerRelation/list`,
    cancelProposal: `${base.url}/newmis36/customerRelation/cancelProposal`,
    approvalProposal: `${base.url}/newmis36/customerRelation/applyProposal`,
    edit: `${base.url}/newmis36/customerRelation/edit`,
    downloadList: `${base.url}/newmis36/customerRelation/downloadList`,
    downloadProList: `${base.url}/newmis36/customerRelation/downloadProList`,
    createOpenUrl:`${base.url}/newmis36/customerRelation/createRelationUrl`,
    relationCount:`${base.url}/newmis36/relationCount/queryAllList`,
  },
  kcharts:{
    scoreList: `${base.url}/newmis36/kcharts/queryScoreList`,
    tradeList: `${base.url}/newmis36/kcharts/queryTradeLogList`,
  },
  active:{
    type:{
      query: `${base.url}/newmis36/activetemplatetype/list`,
      queryAll: `${base.url}/newmis36/activetemplatetype/listAll`,
      save: `${base.url}/newmis36/activetemplatetype/save`,
      edit: `${base.url}/newmis36/activetemplatetype/edit`,
      del: `${base.url}/newmis36/activetemplatetype/del`,
    },
    active:{
      query: `${base.url}/newmis36/activetemplate/list`,
      queryById: `${base.url}/newmis36/activetemplate/queryById`,
      queryDetail: `${base.url}/newmis36/activetemplate/queryDetail`,
      editDetail: `${base.url}/newmis36/activetemplate/editDetail`,
      delDetail: `${base.url}/newmis36/activetemplate/delDetail`,
      save: `${base.url}/newmis36/activetemplate/save`,
      edit: `${base.url}/newmis36/activetemplate/edit`,
      del: `${base.url}/newmis36/activetemplate/del`,
      copy: `${base.url}/newmis36/activetemplate/copy`,
      queryModelList: `${base.url}/newmis36/activetemplate/queryModelList`,
    }
  },
  //支付管理
   payment: {
    list: `${base.url}/newmis36/bank/list`,
    editStatus: `${base.url}/newmis36/bank/editStatus`,
    supplementList: `${base.url}/newmis36/supplement/list`,
    supplementSave: `${base.url}/newmis36/supplement/save`,
    getBankList: `${base.url}/newmis36/supplement/getBankList`,
    getCustomerInfo: `${base.url}/newmis36/supplement/getCustomerInfo`,
  },
  regAct:{
    week: `${base.url}/newmis36/regActDetailReport/queryByWeek`,
  },
  //固定入金金额设置
  amountSetting: {
    list: `${base.url}/newmis36/amountSetting/list`,
    edit: `${base.url}/newmis36/amountSetting/edit`,
    getRule: `${base.url}/newmis36/amountSetting/getRule`,
    editRule: `${base.url}/newmis36/amountSetting/editRule`,
    depositAlertList: `${base.url}/newmis36/amountSetting/depositAlertList`,
    editDepositAlert: `${base.url}/newmis36/amountSetting/editDepositAlert`,
    deleteRow: `${base.url}/newmis36/amountSetting/deleteRow`,
  },
  smsType:{
    list: `${base.url}/newmis36/smsType/getSmsType`,
    edit: `${base.url}/newmis36/smsType/setSmsType`,
  },
  share:{
    tradeShare:{
      list:`${base.url}/newmis36/tradeShare/list`,
      export:`${base.url}/newmis36/tradeShare/export`,
    },
    direct:{
      list:`${base.url}/newmis36/directRecord/list`,
      export:`${base.url}/newmis36/directRecord/export`,
    }
  },
  currencySymbol:{
    list: `${base.url}/newmis36/currencySymbol/list`,
    edit: `${base.url}/newmis36/currencySymbol/edit`,
    delete: `${base.url}/newmis36/currencySymbol/delete`,
  },
  country:{
    getCountryDictParamList: `${base.url}/newmis36/country/getCountryDictParamList`,
    list: `${base.url}/newmis36/country/list`,
    edit: `${base.url}/newmis36/country/edit`,
    delete: `${base.url}/newmis36/country/delete`,
  },
  team:{
    list: `${base.url}/newmis36/team/list`,
    edit: `${base.url}/newmis36/team/edit`,
    delete: `${base.url}/newmis36/team/delete`,
  },
  userTeam:{
    queryTeamListByUser: `${base.url}/newmis36/userTeam/queryTeamListByUser`,
  },
  knowledge:{
    queryList: `${base.url}/newmis36/currencyKnowledge/queryList`,
    edit: `${base.url}/newmis36/currencyKnowledge/edit`,
    delete: `${base.url}/newmis36/currencyKnowledge/delete`,
  },
  optional:{
    getCountryDictParamList: `${base.url}/newmis36/optional/getCountryDictParamList`,
    list: `${base.url}/newmis36/optional/list`,
    edit: `${base.url}/newmis36/optional/edit`,
    delete: `${base.url}/newmis36/optional/delete`,
  },
  relationAnaly:{
    list:`${base.url}/newmis36/relationtrade/list`,
    export:`${base.url}/newmis36/relationtrade/down`,
    statistics:`${base.url}/newmis36/relationtrade/statistics`,
    detail:`${base.url}/newmis36/relationtrade/detail`,
  },
  operations:{
    list: `${base.url}/newmis36/operations/list`,
    edit: `${base.url}/newmis36/operations/edit`,
  },
  coin:{
    list: `${base.url}/newmis36/coin/list`,
    edit: `${base.url}/newmis36/coin/edit`,
    delete: `${base.url}/newmis36/coin/delete`,
  },
  app:{
    appversion:{
      list: `${base.url}/newmis36/appVersion/list`,
      edit: `${base.url}/newmis36/appVersion/edit`,
      delete: `${base.url}/newmis36/appVersion/delete`,
    },
    apptrade:{
      list: `${base.url}/newmis36/appTrade/list`,
      edit: `${base.url}/newmis36/appTrade/edit`,
      delete: `${base.url}/newmis36/appTrade/delete`,
    },
  },
  realToDemo:{
    list: `${base.url}/newmis36/realToDemo/list`,
    edit: `${base.url}/newmis36/realToDemo/edit`,
    delete: `${base.url}/newmis36/realToDemo/del`,
    uploadCustomer: `${base.url}/newmis36/realToDemo/uploadCustomer`,
  },
  appproduct:{
    list: `${base.url}/newmis36/appproduct/list`,
    edit: `${base.url}/newmis36/appproduct/edit`,
    delete: `${base.url}/newmis36/appproduct/del`,
  },
  cashoutlimit:{
    list: `${base.url}/newmis36/cashoutLimit/list`,
    edit: `${base.url}/newmis36/cashoutLimit/edit`,
    delete: `${base.url}/newmis36/cashoutLimit/del`,
  },
  tradingActivitiesCustomer:{
    list: `${base.url}/newmis36/tradingListActivitiesCustomer/list`,
    upload: `${base.url}/newmis36/tradingListActivitiesCustomer/upload`,
  },
  tradingActivitiesTime:{
    list: `${base.url}/newmis36/tradingListActivitiesTime/list`,
    upload: `${base.url}/newmis36/tradingListActivitiesTime/upload`,
  },
  smsTemplate:{
    list: `${base.url}/newmis36/smsTemplate/list`,
    edit: `${base.url}/newmis36/smsTemplate/edit`,
    delete: `${base.url}/newmis36/smsTemplate/del`,
  },
  smsTask:{
    list: `${base.url}/newmis36/smsTask/list`,
    edit: `${base.url}/newmis36/smsTask/edit`,
    delete: `${base.url}/newmis36/smsTask/del`,
    send: `${base.url}/newmis36/smsTask/send`,
    uploadTemplate: `${base.url}/newmis36/smsTask/uploadTemplate`,
  },
  smslog:{
    list: `${base.url}/newmis36/smslog/list`,
    export: `${base.url}/newmis36/smslog/export`,
  },
  // Social Media
  socialMedia:{
    platform: {
      page: `${base.url}/newmis36/social-media/platform/page`,
      add: `${base.url}/newmis36/social-media/platform/save`,
      update: `${base.url}/newmis36/social-media/platform/update`,
      delete: `${base.url}/newmis36/social-media/platform/delete`,
    },
    channel: {
      page: `${base.url}/newmis36/social-media/channel/page`,
      add: `${base.url}/newmis36/social-media/channel/save`,
      update: `${base.url}/newmis36/social-media/channel/update`,
      delete: `${base.url}/newmis36/social-media/channel/delete`,
      options: `${base.url}/newmis36/social-media/channel/options`,
    },
    account: {
      page: `${base.url}/newmis36/social-media/account/page`,
      add: `${base.url}/newmis36/social-media/account/save`,
      update: `${base.url}/newmis36/social-media/account/update`,
      delete: `${base.url}/newmis36/social-media/account/delete`,
      activate: `${base.url}/newmis36/social-media/account/activate`,
      options: `${base.url}/newmis36/social-media/account/options`,
    }
  }
};


